import React, { FC } from 'react';
import styled from 'styled-components';
import { FileAttachment } from 'api/attachments';
import { FileThumbnail } from 'components/atoms/file-thumbnail';

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-bottom: var(--spacing-03);
`;

const StyledFileThumbnail = styled(FileThumbnail)`
  height: 80px;
  width: 136px;
  margin: var(--spacing-03) var(--spacing-03) 0 0;
  div img {
    object-fit: cover;
  }
`;

export const FilesList: FC<{
  files: FileAttachment[];
}> = ({ files }) => (
  <Wrapper>
    {files.map((file) => (
      <StyledFileThumbnail
        key={file.attachmentId}
        fileName={file.name}
        id={file.attachmentId}
        url={file.location}
        thumbUrl={file.thumbLocation}
        isBasicPreview
      />
    ))}
  </Wrapper>
);
